const items = [
  {type: 'option', value: null, label: 'Неважно'},
  {type: 'option', value: '255', label: 'Дом сдан'}
];

export default function getDeadlineItems () {
  if (items.length > 2) {
    return items;
  }

  const now = new Date();
  const nowQuarter = parseInt((now.getMonth() + 3) / 3);
  let nowYear = parseInt(now.getFullYear());
  const endYear = nowYear + 5;

  for (let year = nowYear; year <= endYear; year += 1) {
    let quarter = (year === nowYear) ? nowQuarter : 1;
    items.push({type: 'group', value: year});

    for (; quarter <= 4; quarter += 1) {
      items.push({type: 'option', value: `${year}${quarter}`, label: `${quarter}-й квартал ${year} г.`});
    }
  }

  return items;
}



// WEBPACK FOOTER //
// ./src/utils/dedline.js